import styled from "styled-components";
import { Body2, H2, Subtitle1 } from "melodies-source/Text";
import { useArtistEventContext } from "contexts/ArtistEventContext";
import { GoogleMap } from "./GoogleMap";
import zips from "./zips.json";
import { Card } from "Components/Card";
import { Spinner } from "melodies-source/Spinner";
import { useCustomAppContext } from "contexts/CustomAppContext";
import { CardTitle } from "../Components/CardTitle";
import { useMultiDayEventContext } from "contexts/MultiDayEventContext";
import { Loader } from "./Loader";

export const FanLocations = () => {
  const eventContext = useArtistEventContext();
  const { customApp } = useCustomAppContext();
  const { multidayEvent, multiDayReport, multiDayReportLoading } =
    useMultiDayEventContext();
  const { event, eventLoading } = eventContext;
  const eventAudiencePlural = customApp?.event.audience.plural || "Fans";
  const entriesZips =
    multidayEvent && multiDayReport
      ? multiDayReport.entriesZips
      : eventContext.entriesZips;
  const entriesLoading = multidayEvent
    ? multiDayReportLoading
    : eventContext.entriesLoading;

  const points = entriesZips
    ? Object.entries(entriesZips)?.map(([key, value]) => {
        const { lat, lng } = zips[key] || {};
        const options = {
          center: { lat, lng },
          radius: Math.min(6000, Math.pow(value || 0, 0.8) * 500),
        };
        return options;
      })
    : [];

  const center = event?.coordinates;

  return (
    <StyledCard isElevated>
      {eventLoading || entriesLoading ? (
        <Loader />
      ) : (
        <>
          <CardTitle>{eventAudiencePlural} By Location</CardTitle>
          <Body2>
            A quick look at where tonight's {eventAudiencePlural.toLowerCase()}{" "}
            are from around the venue
          </Body2>
          <Map>
            <GoogleMap
              center={{ lat: center.latitude, lng: center.longitude }}
              points={points}
            />
          </Map>
        </>
      )}
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${H2} {
    color: var(--header-text-color);
    text-align: center;
  }
  ${Body2} {
    color: var(--secondary-text-color);
    text-align: center;
    font-size: 14px;
  }
  & > ${Body2} {
    color: var(--secondary-text-color);
    text-align: center;
  }
  ${Subtitle1} {
    color: var(--text-color);
    margin-top: 4px;
    margin-bottom: 12px;
    text-align: center;
  }
`;

const Map = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 280px;
  border: 1px solid #cccccc;
  border-radius: 6px;
  margin-top: 24px;
  overflow: hidden;
`;
